module.exports = {
	"buying": "Buying",
	"categories": "Categories",
	"dashboard": "Dashboard",
	"invoices": "Invoices",
	"logout": "Logout",
	"miscToggleNavigation": "Toggle navigation",
	"myAccount": {
		"header": "My account",
		"profile": "Profile",
		"informationUpdated": "Information updated!",
		"organizations": "Seller accounts",
		"sellerRequests": "User list requests",
		"settings": "Settings",
		"updateProfileBtn": "Update profile",
		"userModel": "User Model"
	},
	"sellerDashboard": "Seller Dashboard",
	"sellerDashboard_plural": "Seller Dashboards",
	"sellerDirectory": "Seller Directory",
	"selling": "Selling",
	"versionManager": "Version Manager"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/menu.json5
// module id = 1941
// module chunks = 6